import logo from "./logo.svg";
import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "./protected-route";
import {  getUserSession, isTokenValid } from "../src/utils";

import axiosInstance from "../src/services/axiosInstance";
import "./App.css";
import Login from "./Login/Login";
import Home from "./Login/Homepage/Home";
import { getCookie, setCookie } from "./commonUtils";
/*istanbul ignore next*/
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  let currentAccessToken = getCookie("google_access_token")
  const isAuthenticated = !!getCookie("google_access_token")

  // const isAuthenticated = !!(localStorage.getItem('google_access_token'));
  // const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('google_access_token'));

  // useEffect(() => {
  //   const handleStorageChange = () => {
  //     setIsAuthenticated(!!localStorage.getItem('google_access_token'));
  //   };

  //   window.addEventListener('storage', handleStorageChange);
  //   return () => window.removeEventListener('storage', handleStorageChange);
  // }, []);

  useEffect(() => {
    const handleTokenValidation = async () => {
      const tokenFromCookie = getCookie("authToken");
      if(tokenFromCookie){
        let isToken = await isTokenValid(tokenFromCookie);
        if (isToken) {
          const bearerToken = `${tokenFromCookie}`;
          setCookie("authToken", bearerToken);
          setIsLoggedIn(true);
          navigate('/home', { replace: true });
          // axiosInstance.defaults.headers.Authorization = tokenFromCookie;
          getUserSession();
        } 
        else {
          setIsLoggedIn(false);
        }
      }
     
    };
    handleTokenValidation();
  }, []);

  // useEffect(() => {
  //   const handleTokenValidation = async () => {
  //     const paramsString = window.location.search;
  //     const searchParams = new URLSearchParams(paramsString);
  //     const existingToken = searchParams.get("token") || getCookie("token");
  //     const tokenValid = await isTokenValid(existingToken);
  //     if (tokenValid) {
  //       document.cookie = `token=${existingToken};path=/home`;
  //       if (searchParams.has("token")) {
  //         searchParams.delete("token");
  //         window.history.replaceState({}, "", `${window.location.pathname}`);
  //       }
  //       setIsLoggedIn(true);
  //       navigate('/home', { replace: true });
  //       axiosInstance.defaults.headers.Authorization = existingToken;
  //       getUserSession();
  //     } else {
  //       setIsLoggedIn(false);
  //     }
  //   };
  //   handleTokenValidation();
  // }, []);

  return (
    <div className="App">
      <Routes>
        <Route
          path="/home"
          element={
            <ProtectedRoute
              isAuthenticated={isLoggedIn}
              element={<Home user={user} />}
            />
          }
        />
        <Route path="/" element={<Login setUser={setUser} setIsLoggedIn={setIsLoggedIn}/>} />
        <Route path="/login" element={<Login setUser={setUser} setIsLoggedIn={setIsLoggedIn}/>} />
      </Routes>
    </div>
  );
}

export default App;
